import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import zh from './locales/zh.json';

// Read persisted locale from ui-store localStorage
function getPersistedLocale(): string {
  try {
    const raw = localStorage.getItem('nopanel-ui');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed.state?.locale) return parsed.state.locale;
    }
  } catch { /* ignore */ }
  return 'zh';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
  },
  lng: getPersistedLocale(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

function syncDocumentLang(lng: string) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng.startsWith('zh') ? 'zh-CN' : 'en';
  }
}

syncDocumentLang(i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
